import { Close as CloseIcon, Delete as DeleteIcon, Save as SaveIcon } from '@mui/icons-material'
import { IconButton, Stack } from '@mui/material'
import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'

import { FlexBox } from 'components/Box'
import { Select, SelectAutocomplete } from 'components/Form'
import { SelectOption } from 'components/Select'
import { userWorkspaceRoleOptions } from 'features/user'
import { WorkspaceSlice } from '../hooks/useGetWorkspaceOptions'
import { UserWorkspaceForForm } from '../types'
import { UserWorkspacesContext } from './contexts/UserWorkspacesContext'
import { useRemovePublisherFromWorkspace } from './hooks/useRemovePublisherFromWorkspace'
import { CommonSchema } from './schemas'

type Props = {
  workspaceOptions: SelectOption<WorkspaceSlice>[]
}

export const EditForm = ({ workspaceOptions }: Props): React.JSX.Element => {
  const { userWorkspaces } = useContext(UserWorkspacesContext)

  const {
    control,
    formState: { isDirty },
    reset,
    watch,
  } = useFormContext<CommonSchema>()
  const { userId, workspaceId } = watch()
  const { removePublisherFromWorkspace } = useRemovePublisherFromWorkspace({
    workspaceId: workspaceId.value,
  })

  return (
    <Stack
      direction='row'
      sx={{ gap: 2 }}
    >
      <SelectAutocomplete<CommonSchema, WorkspaceSlice>
        control={control}
        disabled
        disabledOptions={userWorkspaces.map(({ workspaceId }: UserWorkspaceForForm) => workspaceId)}
        name='workspaceId'
        options={workspaceOptions}
      />

      <Select
        control={control}
        name='role'
        options={userWorkspaceRoleOptions()}
      />

      <FlexBox axis='x'>
        {isDirty ? (
          <>
            <IconButton type='submit'>
              <SaveIcon data-cy='save-icon' />
            </IconButton>

            <IconButton onClick={() => reset()}>
              <CloseIcon data-cy='close-icon' />
            </IconButton>
          </>
        ) : (
          <IconButton onClick={() => removePublisherFromWorkspace({ userId, workspaceId })}>
            <DeleteIcon data-cy='delete-icon' />
          </IconButton>
        )}
      </FlexBox>
    </Stack>
  )
}
